import { assignInput, BaseModel } from '../base.model';

export class MPRModel extends BaseModel {
  VPJobID: string = '';
  StartDate: Date;
  EndDate: Date;
  HoursWorked: string = '';
  VPJobId?: string; // some use camel case?

  Recruiter: any;
  Status: any;

  editable: any;

  constructor(o: unknown = null) {
    super(o);
    // WI 35894: re-apply o after this class's field initializers (see assignInput in base.model.ts).
    assignInput(this, o);
  }
}
